import React from 'react';
import { RangeFacet } from '@1po/1po-bff-fe-spec/generated/catalog/references/iam/response/GetIAMReferencesResponse';
import { InputRange } from 'UI';
import { isDefaultRange } from '../Filter.shared';
import { FiltersRange } from '../Filter.types';

interface DebouncedSliderProps {
  min: number;
  max: number;
  isSliderDisabled: boolean;
  facet: RangeFacet;
  filterValues: [number, number];
  setRangeFilter: (id: string, range?: FiltersRange) => void;
}

const DebouncedSlider = ({ min, max, isSliderDisabled, facet, filterValues, setRangeFilter }: DebouncedSliderProps) => {
  return (
    <InputRange
      value={filterValues}
      min={min}
      max={max}
      disabled={isSliderDisabled}
      step={0.1}
      onChange={(e) => {
        const [eMin, eMax] = e;
        if (isDefaultRange(eMin, eMax, min, max)) {
          setRangeFilter(facet.id);
        } else {
          setRangeFilter(facet.id, { min: eMin, max: eMax });
        }
      }}
    />
  );
};

export default DebouncedSlider;
